export const cardActivation = {
    doubleFetchEnabled: true,
    doubleFetchTimeout: 5000,
};
